import { ErrorHandler, Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';

@Injectable()
export class MonitoringErrorHandler extends ErrorHandler {
  constructor() {
    super();
  }

  // send all errors to datadog
  override handleError(error: Error): void{
    super.handleError(error);
    datadogRum.addError(error);
  }
}
